"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgricultureConstants = void 0;
class AgricultureConstants {
    constructor() {
        this.emissionFactor = 0.046;
        this.emissionFactorUnit = "tCO2e/ha/d";
    }
}
exports.AgricultureConstants = AgricultureConstants;
